export const apiBaseUrl =
  process.env.REACT_APP_NODE_ENV === "development"
    ? process.env.REACT_APP_API_BASE_URL
    : process.env.REACT_APP_API_BASE_URL_PROD;
